module.exports = __webpack_public_path__ + "static/img/search_1.2be2d94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/search_1.png
// module id = Ak/V
// module chunks = 1